import {useEffect, useRef, useState} from 'react';
import {Icon} from './Icon';

/** Copie un identifiant et l'annonce : un UID de 28 caractères ne se retape pas à la main. */
export function CopyCode({value, label = "l'identifiant"}: {value: string; label?: string}) {
  const [copied, setCopied] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => () => { if (timer.current) clearTimeout(timer.current); }, []);

  return <>
    <button type="button" className="icon-btn" aria-label={`Copier ${label}`} onClick={async () => {
      try {
        await navigator.clipboard?.writeText(value);
        setCopied(true);
        if (timer.current) clearTimeout(timer.current);
        timer.current = setTimeout(() => setCopied(false), 2000);
      } catch {
        // Le presse-papiers peut être refusé par le navigateur : l'identifiant reste sélectionnable.
      }
    }}><Icon name="copy" size={13} /></button>
    <span className="sr-only" aria-live="polite">{copied ? 'Copié' : ''}</span>
  </>;
}
